
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    //export class ProductsFranchiseeDialog extends Serenity.PropertyDialog<any, any> {
    export class ProductTeacherDialog extends Serenity.EntityDialog<ProductTeacherShareRow, any> {
        protected getFormKey() { return ProductTeacherForm.formKey; }
        protected getIdProperty() { return ProductTeacherShareRow.idProperty; }
        protected getLocalTextPrefix() { return ProductTeacherShareRow.localTextPrefix; }
        protected getService() { return ProductTeacherShareService.baseUrl; }

        protected form = new ProductTeacherForm(this.idPrefix);
        public rowids: string;
      
        private checkGrid: ProductsGrid;
        constructor(gridToRefresh, FormMode, selectedids) {
       // constructor() {
            super();

            this.form = new ProductTeacherForm(this.idPrefix);
            /*debugger;*/
            this.rowids = selectedids;

        }

        loadEntity(entity: ProductsRow) {
            //debugger;
            super.loadEntity(entity);
            //debugger;
            this.form.RowIds.value = this.rowids;
            this.form.RowIds.getGridField().toggle(false);

        }

        onSaveSuccess(response) {
            super.onSaveSuccess(response);
            //debugger;
            if (this.form.RowIds.value != "") {
                Q.notifySuccess("Added sucessfully");
                //this.Questionsgrid.rowSelection.resetCheckedAndRefresh();
                //this.Questionsgrid.refresh();
            }

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            // We could also remove delete button here, but for demonstration 
            // purposes we'll hide it in another method (updateInterface)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }

    }
}